export enum TrsType {
    ANY = 'ANY',
    STANDARD = 'STANDARD',
    AIRPORT = 'AIRPORT'
}
